import React from 'react';
import { useTranslation } from 'react-i18next';
import { entries, filter, map, omit, sortBy, values } from 'lodash';

import { ICategory } from '@/models';

import Accordion from '@/components/v2/UI/Accordion';
import Checkbox from '@/components/v2/Forms/Checkbox';

import useQueryParams from '@/hooks/useQueryParams';
import { useFilterHandler } from '@/hooks/products/use-filter-handler';

interface Props {
  category: ICategory;
}

const GENERIC_FILTERS = new Set([
  'fit',
  'temperature',
  'insulationlevel',
  'activityintensity',
  'sockscushion',
  'socksthickness',
  'socks_height',
  'sockscompression',
  'materials',
  'shoes_features'
]);

const GenericFilters: React.FC<Props> = ({ category }) => {
  const { t } = useTranslation();
  const handler = useFilterHandler();
  const [query] = useQueryParams();
  const filters = sortBy(
    map(
      filter(entries(omit(category.filters, ['color', 'size'])), ([key]) => {
        return GENERIC_FILTERS.has(key);
      }),
      ([key, options]) => ({
        key: key,
        name: t(`FILTERS.${key}`),
        options: sortBy(
          values(options) as { label: string; value: string }[],
          'value'
        )
      })
    ),
    'name'
  );

  return (
    <>
      {filters.map(({ key, name, options }, idx) => (
        <Accordion
          as="ul"
          key={idx}
          name={name}
          className="px-6 py-3 space-y-3 xl:px-0"
        >
          {options.map(({ label, value }) => (
            <li key={value}>
              <Checkbox
                name={key}
                checked={Boolean(query[key]?.includes(value))}
                onChange={handler(value)}
              >
                {label}
              </Checkbox>
            </li>
          ))}
        </Accordion>
      ))}
    </>
  );
};

export default GenericFilters;
